module.exports = __webpack_public_path__ + "static/media/arrowUp.96529aa7.svg";